import RedirectPage from '../page';

const RedirectRoutes = [
  {
    path: 'lesson/:id',
    element: <RedirectPage />,
  },
];

export default RedirectRoutes;
